export default __webpack_public_path__ + "static/media/placeholder_blank-es-mobile.6b153d85.png";